<template>
  <div>
    <dv-border-box-7 >

      <div class="bg-color-black" style="height: 100%;width: 100%;">
        <div class="d-flex pt-2 pl-2" style="height:20px;">
          <div style="font-size:16px;color:#5cd9e8;float:left;padding:5px"> 
            <span v-if="unitCode.indexOf('00000000')!=-1" >各县区交易额对比（万元）</span>
            <span v-else >各乡镇交易额对比（万元）</span>
             <dv-decoration-1 style="width:1.25rem;height:.15rem; position:relative;top:-.0375rem;" />
          </div>
        </div>
        <div id="bottomLeft" style="width:98%;margin-left:2%;height:95%">

        </div>

      </div>
    </dv-border-box-7>
  </div>
</template>

<script>
  import * as echarts from "echarts";

  export default {
    props: {


    },
    data(){
      return{
        mTime:{},
        index:0,
        unitCode:localStorage.getItem("unitCode"),
      }
    },
    mounted() {
       this.showData();
    },
    methods: {
      showData() {
        this.$http.get("/web/tradeData?unitCode=" + localStorage.getItem("unitCode"))
        	.then((
        		res) => {
        	var names = [];
        	var values = [];
        	for (var i = 0; i < res.data.data.tradeAmtList.length; i++) {
        	  names.push(res.data.data.tradeAmtList[i].unitName);
        	  values.push(res.data.data.tradeAmtList[i].amount/10000);
        	}
          console.log(names);
        	this.chart_bar1('bottomLeft', '交易额', names, values)

        	});

      },
      chart_bar1(id, name, data, value) {
        var option = {

          textStyle: {
            fontSize: 12,
            color: '#FFFFFF',
          },
          color: ['#60a786'],
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          label: {
            show: true, // 显示数值
            position: 'top' // 数值显示在柱状图的上方
            // 或者可以设置为：inside，在柱状图内部显示数值
          },
          grid: {
            left: '0%',
            right: '4%',
            top:'10%',
            bottom: '6%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: data,
            axisTick: {
              alignWithLabel: true
            },

            axisLabel: {
              interval: 0,
              rotate: -20,
              textStyle: {
                color: "#ebf8ac", //X轴文字颜色
              },
            }
          }],
          yAxis: [{
            type: 'value',
            axisLabel: {
              interval: 0,
              rotate: 0,
              textStyle: {
                color: "#ebf8ac", //X轴文字颜色
              },
            }
          }],
          series: [{
            name: name,
            type: 'bar',
            barWidth: '30%',
            data: value,
            itemStyle: {
			    normal: {
			      barBorderRadius: 5,
			      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
			        { offset: 0, color: "#004D40" },
			        { offset: 1, color: "#3EACE5" }
			      ])
			    }
			  },
          }]
        };
        var myChart = echarts.init(document.getElementById(id));
        myChart.setOption(option);

     	  clearInterval(this.mTime);
	         this.mTime = setInterval(() =>{
				 
            myChart.dispatchAction({
	             type: 'showTip',
	             seriesIndex: 0,
	             dataIndex: this.index
	           });
	           if(this.index > data.length-2) {
	             this.index = 0;
	           }
			   else{
				   this.index++;
				   
			   }
	         }, 1000)

        window.addEventListener("resize", function() {
          myChart.resize();
        });
      },
      destroyed() {
	clearInterval(this.mTime);
    window.onresize = null;
  }
    },

  }
</script>

<style lang="scss" scoped>

</style>
